import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import QualityBadge from "./QualityBadge";
import type { Preceptor } from "@/lib/mockData";

interface PreceptorCardProps {
  preceptor: Preceptor;
  index: number;
}

const PreceptorCard = ({ preceptor, index }: PreceptorCardProps) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25, delay: index * 0.05 }}
      onClick={() => navigate(`/search?q=${encodeURIComponent(preceptor.name)}`)}
      className="flex items-center gap-3 rounded-md border border-border bg-muted/50 px-3 py-2 cursor-pointer hover:bg-muted transition-colors"
    >
      <QualityBadge rating={preceptor.rating} size="sm" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-primary hover:underline truncate">{preceptor.name}</p>
        <p className="text-xs text-muted-foreground">{preceptor.specialty}</p>
        <div className="flex items-center gap-3 mt-0.5">
          <span
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/preceptor?name=${encodeURIComponent(preceptor.name)}`);
            }}
            className="text-[10px] text-primary font-medium hover:underline cursor-pointer"
          >
            {preceptor.reviewCount} reviews
          </span>
          <span className="text-[10px] text-primary font-medium">
            {preceptor.wouldTakeAgain}% would take again
          </span>
          <span className="text-[10px] text-muted-foreground">
            Difficulty: {preceptor.difficulty.toFixed(1)}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default PreceptorCard;
